// Neutral gray square shown in the gallery for a media (image or video) still uploading, until the
// real server thumbnail replaces it. Inline data URI so it needs no network round-trip or bundled
// asset (and the carousel doesn't retry-fetch it).
export const MEDIA_PLACEHOLDER_THUMBNAIL =
  'data:image/svg+xml;utf8,' +
  encodeURIComponent(
    `<svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48">` +
      `<rect width="48" height="48" fill="#e5e7eb"/>` +
      `</svg>`,
  );
